import { Shield, Search, Award, Users, CheckCircle, BookOpen } from 'lucide-react';

export function TrustSection() {
  const features = [
    {
      icon: Search,
      title: 'Investigación Exhaustiva',
      description: 'Analizamos ingredientes, certificaciones y estudios científicos de cada producto.',
    },
    {
      icon: Shield,
      title: 'Análisis Imparcial',
      description: 'Nuestras recomendaciones se basan en calidad, no en comisiones de afiliado.',
    },
    {
      icon: Award,
      title: 'Expertos en Salud',
      description: 'Equipo formado por nutricionistas y especialistas en suplementación.',
    },
    {
      icon: Users,
      title: 'Comunidad Activa',
      description: 'Miles de lectores confían en nuestros análisis cada mes.',
    },
    {
      icon: CheckCircle,
      title: 'Actualización Constante',
      description: 'Revisamos y actualizamos nuestros rankings regularmente.',
    },
    {
      icon: BookOpen,
      title: 'Información Clara',
      description: 'Explicamos todo en lenguaje sencillo, sin tecnicismos innecesarios.',
    },
  ];

  return (
    <section className="py-16">
      <div className="container-wide">
        {/* Header */}
        <div className="mb-12 text-center">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
            <Shield className="h-4 w-4" />
            Por Qué Confiar en Nosotros
          </span>
          <h2 className="font-display text-3xl font-bold md:text-4xl">
            Tu salud merece información de calidad
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-muted-foreground">
            En Tu Silla Ideal nos tomamos muy en serio la responsabilidad de ayudarte a elegir 
            las mejores sillas de escritorio. Así es como trabajamos:
          </p>
        </div>

        {/* Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group rounded-xl border border-border bg-card p-6 transition-all duration-300 hover:border-primary/20 hover:shadow-lg"
            >
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                <feature.icon className="h-6 w-6" />
              </div>
              <h3 className="mb-2 font-display text-lg font-semibold">
                {feature.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 rounded-2xl bg-primary p-8 text-primary-foreground md:p-12">
          <div className="grid gap-8 text-center md:grid-cols-4">
            <div>
              <p className="font-display text-4xl font-bold md:text-5xl">500+</p>
              <p className="mt-1 text-sm opacity-90">Productos Analizados</p>
            </div>
            <div>
              <p className="font-display text-4xl font-bold md:text-5xl">50K+</p>
              <p className="mt-1 text-sm opacity-90">Lectores Mensuales</p>
            </div>
            <div>
              <p className="font-display text-4xl font-bold md:text-5xl">98%</p>
              <p className="mt-1 text-sm opacity-90">Satisfacción</p>
            </div>
            <div>
              <p className="font-display text-4xl font-bold md:text-5xl">4.9★</p>
              <p className="mt-1 text-sm opacity-90">Valoración Media</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}